import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess} from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { cResource } from 'src/types/resource';
import { cAdmission } from 'src/types/admission';
import { tag_returndata } from 'src/types/tag_returndata';
import { resourceType_returndata } from 'src/types/resource_returndata';
import { v4 as uuidv4  } from 'uuid';
import { resourcegroupname_returndata } from 'src/types/resourcegroupname_returndata';
import { resourcegroupname } from 'src/types/resourcegroupname';
import { cClass } from 'src/types/class';
import { HubConnection } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { admissionBasedUpgrade, cAdmissionBasedUpgrade } from 'src/types/admissionbasedupgrades';


@Component({
  selector: 'app-admissionbasedupgradesedit',
  templateUrl: './admissionbasedupgradesedit.component.html',
  styleUrls: ['./admissionbasedupgradesedit.component.css']
})
export class AdmissionbasedupgradeseditComponent implements OnInit {
    VenueID: string = localStorage.getItem("SmartVenueID")!;
    upgrade: cAdmissionBasedUpgrade;
    httpResponse: any;
    id: string;
    stateOptionsRes: any;
    stateOptionsPPP: any;
    stateOptionsMI: any;
    stateOptionsPart: any;
    stateOptions: any;
    stateOptionsComplexSimple: any;

    packageLen: number = 0;
    availableResources: any;
    selectedResources: any = [];
    stateOptionsSelMode: any;
    stateOptionsSel: any;
    stateOptionsQty: any;
    stateOptionsQty2: any;
    stateOptionsStart: any;
    stateOptionsBool: any;
    stateOptionsVisibility: any;
    stateOptionsPrice: any;

    availableAdmissions: any = [];
    selectedAdmissions: any = [];
    draggedAdmission: any;
    DepositPolicies: any;

    builtResources: any;
    builtAdmissions: any;

    classes: cClass[];

    tags: any;
    items: any;
    activeIndex: number;

    upgradeNameValid: boolean = true;
    upgradeDescValid: boolean = true;

    itinerary: string = "";
    discrepantitinerary: string[] = [];

    availableResourceGroups: resourcegroupname[] = [];
    selectedItems: any;

    showDialog: boolean;

    hubConnection: HubConnection;

    HTMLbmxurl: string = bmxurl;
    Identifier: string = uuidv4();
    FileChosen: string = "";

    Confirmations: any[];
    Warnings: any[];

    SortedItinerary: any[];

    AccessAllowed: boolean = false;
    CompletedLoading: boolean = false;

    BookingQuestionnaires: any[] = [];
    CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

    delayBookingStateOptions: any[] = [];

    stateOptionsRangeType: any[]
    stateOptions3: any[];

    bookingCannotBeMadeWithinXMinutesD: number = 0;
    bookingCannotBeMadeWithinXMinutesH: number = 0;
    bookingCannotBeMadeWithinXMinutesM: number = 0;

    bookingscannotbemadeafterxDays: number = 0;

    LinkedAdmissions: boolean = false;

    CurrentSelectedAdmission: cAdmission;
    CurrentSelectedLinkedAdmission: cAdmission;

    publicDepositPolicy: boolean = true;

    BookingTimeout: Number = 5;


    constructor(private route: ActivatedRoute, 
      private http: HttpClient, 
      private router: Router, 
      private messageService: MessageService, 
      private auth: AuthService, private globalService: GlobalService) {
      this.stateOptionsRes = [{ label: 'Shared', value: false }, { label: 'Exclusive', value: true }];
      this.stateOptionsPPP = [{ label: 'Per Booking', value: true }, { label: 'Per Person', value: false }];
      this.stateOptions = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
      this.stateOptionsMI = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
      this.stateOptionsPart = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
      this.stateOptionsPrice = [{ label: 'Fixed Price', value: true }, { label: 'Per Person', value: false }];
      this.stateOptionsBool = [{ label: 'Yes', value: false }, { label: 'No', value: true }];
      this.stateOptionsVisibility = [{ label: 'Hidden', value: 'NEITHER' }, { label: 'Public Bookings Only', value: 'PUBLIC' }, { label: 'Preview/Venue Only', value: 'VENUE' }, { label: 'Public and Venue Bookings', value: 'BOTH' }];

      this.stateOptionsRangeType = [{ label: 'Date Range', value: 0 }, { label: 'Days before', value: 1 }];

      this.stateOptionsSel =  [{ label: 'Customer chooses from any', value: "ANY" }, { label: 'Customer chooses from list', value: "LIST" }, { label: 'System chooses from any', value: "SYSTEMANY" }, { label: 'System chooses from list', value: "SYSTEMLIST" }];
      this.stateOptionsQty =  [{ label: 'Group Size', value: "GROUPSIZE" }, { label: 'Participant', value: "PARTICIPANT" }, { label: 'Customer Chooses', value: "CUSTOM" }];
      
      this.stateOptionsQty2 =  [{ label: 'Group Size', value: "GROUPSIZE" }, { label: 'Participant', value: "PARTICIPANT" }];
      
      this.stateOptionsStart = [{ label: 'At Start', value: "ATSTART"}, { label: 'At End', value: "ATEND"}, { label: 'Offset', value: "OFFSET"}];
      this.stateOptionsComplexSimple = [{ label: 'Simple', value: 'SIMPLE' }, { label: 'Complex', value: "COMPLEX"}];

      this.delayBookingStateOptions = [{label: 'No', value: false}, {label: 'Yes', value: true}];

      this.stateOptions3 = [{ label: 'Fixed Amount', value: "FIXED" }, { label: 'Percentage', value: "PERCENTAGE" }];

      this.loadResources(false);

      this.upgrade = {
        id: null,
        name: "",
        description: "",
        imageurl: "",
        imageguid: null,
        disabled: false,
        venueid: this.VenueID,
        resources: [],
        upgradeid: null,
        optional: false,
        quantity: 0
    };

    if(this.upgrade.imageguid == null || this.upgrade.imageguid == "")
    {
      this.Identifier = uuidv4();
      this.upgrade.imageguid = this.Identifier;
    }

    }

    add_years(dt,n) 
    {
    return new Date(dt.setFullYear(dt.getFullYear() + n));      
    }

    addYears(date: Date, years: number): Date {
      date.setFullYear(date.getFullYear() + years);
      return date;
    }

    uploadedFile(event){
      this.upgrade.imageurl = event.originalEvent.body.data;
      let newNonce = uuidv4();

      this.FileChosen = event.originalEvent.body.data + "?n=" + newNonce;
    }

    onErrorFileUpload(event){
      this.messageService.add({ severity: 'error', summary: 'Image not uploaded', detail: 'Could not upload image: ' + event.error });
    }

    ngOnInit(): void {

      this.globalService.setSmallScreenMenu(false);

      let userid = localStorage.getItem("SmartUserID");

      this.http.get(bmxurl + "User/" + userid).subscribe(async response => {
        this.httpResponse =  (response as users_returndata)
        if(this.httpResponse.succeeded)
        {
          let user = this.httpResponse.data;
  
          if(getAccess("PACKAGE", user)){
            this.AccessAllowed = true;

          this.id = this.route.snapshot.paramMap.get('id');
    
          if(this.id != "0")
          {
              this.tags = (response as tag_returndata).data;
              this.http.get(bmxurl + "admissionbasedupgrade/" + this.VenueID + "/" + this.id).subscribe(response => {
                this.httpResponse = response;
  
                this.Identifier = (this.httpResponse.data as cAdmissionBasedUpgrade).imageguid;
  
                this.upgrade = {
                  id: (this.httpResponse.data as cAdmissionBasedUpgrade).id,
                  upgradeid: (this.httpResponse.data as cAdmissionBasedUpgrade).upgradeid,
                  name: (this.httpResponse.data as cAdmissionBasedUpgrade).name,
                  description: (this.httpResponse.data as cAdmissionBasedUpgrade).description,
                  imageurl: (this.httpResponse.data as cAdmissionBasedUpgrade).imageurl,
                  imageguid: (this.httpResponse.data as cAdmissionBasedUpgrade).imageguid,
                  disabled: (this.httpResponse.data as cAdmissionBasedUpgrade).disabled,
                  venueid: (this.httpResponse.data as cAdmissionBasedUpgrade).venueid,
                  resources: (this.httpResponse.data as cAdmissionBasedUpgrade).resources,
                  optional: (this.httpResponse.data as cAdmissionBasedUpgrade).optional,
                  quantity: (this.httpResponse.data as cAdmissionBasedUpgrade).quantity
                }

                this.Identifier = this.upgrade.imageguid;
  
                if(this.upgrade.imageguid == null || this.upgrade.imageguid == "")
                {
                  this.Identifier = uuidv4();
                  this.upgrade.imageguid = this.Identifier;
                }
                
                
                this.FileChosen = this.upgrade.imageurl;
      
              }, error => {
              });
          }
          }
  
          this.CompletedLoading = true;

        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
      });


    }

    genRandomNum()
    {
      return Math.floor((Math.random()*10000)+1).toString();
    }

    loadResourceGroups(showdisabled: boolean) {
      this.http.get(bmxurl + "ResourceGroupNameList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
        this.availableResourceGroups = (response as resourcegroupname_returndata).data;
      }, error => {
      });
    }

    loadResources(showdisabled: boolean) {
      this.http.get(bmxurl + "ResourceListForPackage/" + this.VenueID + "/" + showdisabled).subscribe(response => {
        let allresources = (response as resourceType_returndata).data.filter(obj => obj.eventid == null || obj.eventid == '')
        
        this.availableResources = allresources;
      }, error => {
      });
    }

    returnToList() {
      this.router.navigateByUrl("/admissionbasedupgrades");
    }
    
    AddToResources(resource){
      if(this.upgrade.resources == null)
        this.upgrade.resources = [];

        if(resource.isresourcecontainer)
        {
          let newRes: cResource = {
            groupname: "",
            id: uuidv4(),
            resourceId:resource.resourceId,
            name:resource.name,
            useClasses:resource.useClasses,
            exclusive:resource.exclusive,
            eventid: resource.eventid,
            concurrentUses:resource.concurrentUses,
            maxConcurrent:resource.maxConcurrent,
            disabled:resource.disabled,
            venueId:resource.venueId,
            colour:resource.colour,
            orderindex:resource.orderindex,
            length:resource.length,
            classes:resource.classes,
            showonbooking:resource.showonbooking,
            resources:resource.resources,
            isresourcecontainer:resource.isresourcecontainer,
            isconstructed: resource.isconstructed,
            price:resource.price,
            fixedprice:resource.fixedprice,
            resourcegroupname: resource.resourcegroupname,
            tags: resource.tags,
            resourcegroup: resource.resourcegroup,
            selectionmode: "SYSTEMANY",
            selectableresources: resource.selectableresources,
            startwhen: "ATSTART",
            startTimeOffset: 0,
            optional: false,
            quantityselector: "GROUPSIZE",
            quantity: resource.quantity,
            mode: "COMPLEX",
            inline: false,
            ignore: false,
            admissions: null,
            inProgress: true,
            originatingid: '',
            wasoptional: false,
            wasselected: false,
            isupgrade: true,
            packageupgradeid: resource.packageupgradeid,
            showinitinerary: resource.showinitinerary,
            showondaysheet: resource.showondaysheet,
            cansplit: resource.cansplit
          }
  
          this.upgrade.resources.push(newRes);
          newRes = null;
        }
        else
        {
          let newRes: cResource = {
            groupname: "",
            id: uuidv4(),
            resourceId:resource.resourceId,
            name:resource.name,
            useClasses:resource.useClasses,
            exclusive:resource.exclusive,
            eventid: resource.eventid,
            concurrentUses:resource.concurrentUses,
            maxConcurrent:resource.maxConcurrent,
            disabled:resource.disabled,
            venueId:resource.venueId,
            colour:resource.colour,
            orderindex:resource.orderindex,
            length:resource.length,
            classes:resource.classes,
            showonbooking:resource.showonbooking,
            resources:resource.resources,
            isresourcecontainer:resource.isresourcecontainer,
            isconstructed: resource.isconstructed,
            price:resource.price,
            fixedprice:resource.fixedprice,
            resourcegroupname: resource.resourcegroupname,
            tags: resource.tags,
            resourcegroup: resource.resourcegroup,
            selectionmode: "",
            selectableresources: resource.selectableresources,
            startwhen: "ATSTART",
            startTimeOffset: resource.startTimeOffset,
            optional: resource.optional,
            quantityselector: "GROUPSIZE",
            quantity: resource.quantity,
            mode: "SIMPLE",
            inline: true,
            ignore: false,
            admissions: null,
            inProgress: true,
            originatingid: '',
            wasoptional: false,
            wasselected: false,
            isupgrade: true,
            packageupgradeid: resource.packageupgradeid,
            showinitinerary: resource.showinitinerary,
            showondaysheet: resource.showondaysheet,
            cansplit: resource.cansplit
          }
  
          this.upgrade.resources.push(newRes);
          newRes = null;
        }
    }

    removeFromResources(resource){
      this.upgrade.resources = this.upgrade.resources.filter(obj => obj.id !== resource.id);
    }
    
    updateData() {

      if (this.DoValidCheck())
      {
        let AllOK: boolean = true;

        if(this.upgrade.resources.length == 0)
        {
          this.messageService.add({ severity: 'error', summary: 'Resource missing', detail: 'You must have at least 1 Resource' });
          AllOK = false;
        }

        // let resourceHasNoLength: boolean = false;
        // this.upgrade.resources.forEach(element => {
        //   if(element.length == 0)
        //     resourceHasNoLength = true;
        // });

        // if(resourceHasNoLength)
        // {
        //   this.messageService.add({ severity: 'error', summary: 'Resource length Issue', detail: 'All Resources must have a length greater than 0' });
        //   AllOK = false;
        // }

        if(AllOK)
        {
          this.upgrade.resources.forEach(element => {
            if(element.selectionmode == "ANY" || element.selectionmode == "SYSTEMANY")
            {
              element.selectableresources = element.resources;
            }
          });

          if (this.id == "0") {

            let index: number = 0;
            this.upgrade.resources.forEach(res => {
              res.orderindex = index;
              let innerindex: number = 0;
              res.resources.forEach(innerres => {
                innerres.orderindex = innerindex;
                innerindex ++;
              });
              index ++;
            });

            this.upgrade.resources.forEach(element => {
              if(element.mode == "SIMPLE")
              {
                element.selectionmode = '';
                element.startwhen = '';
              }
            });

            this.upgrade.name = this.upgrade.name.trim();

            this.http.post<admissionBasedUpgrade>(bmxurl + "/AdmissionBasedUpgrade", this.upgrade).subscribe(response => {
              this.httpResponse = response
              if (this.httpResponse.succeeded) {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Upgrade successfully created' });
                this.router.navigateByUrl("/admissionbasedupgrades");
              }
              else
              {
                this.messageService.add({ severity: 'error', summary: 'Error Occurred', detail: this.httpResponse.messages[0] });
              }
            }, error => {
              this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: error.messages });
            })
          }
          else
          {
            this.upgrade.disabled = false;

            let index: number = 0;
            this.upgrade.resources.forEach(res => {
              res.orderindex = index;
              let innerindex: number = 0;
              res.resources.forEach(innerres => {
                innerres.orderindex = innerindex;
                innerindex ++;
              });
              index ++;
            });

            this.upgrade.name = this.upgrade.name.trim();
            
            this.http.put<admissionBasedUpgrade>(bmxurl + "/AdmissionBasedUpgrade", this.upgrade).subscribe(response => {
              this.httpResponse = response
              if (this.httpResponse.succeeded) {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Upgrade successfully updated' });
                this.router.navigateByUrl("/admissionbasedupgrades");
              }
              else
              {
                this.messageService.add({ severity: 'error', summary: 'Error Occurred', detail: this.httpResponse.messages[0] });
              }
            }, error => {
              this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: error.messages });
            })
          }
        }
      }
    }

    delay(ms: number) {
      return new Promise( resolve => setTimeout(resolve, ms) );
  }

    convertTime(mins: number)
    {
        var hours = Math.floor(mins / 60);          
        var minutes = mins % 60;
      
        return hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0');
    }

    removeImage(){
      this.FileChosen = null;
      this.upgrade.imageurl = null;
    }

    DoValidCheck()
    {
      let AllValid = true;

      if(this.upgrade.name == null || this.upgrade.name == "")
      {
        AllValid = false;
        this.upgradeNameValid = false;
        if(this.activeIndex !=0)
          this.messageService.add({ severity: 'error', summary: 'Name Required', detail: 'You must provide a name for your Upgrade, please return to the first tab and correct this.' });
      }
      else
      {
        this.upgradeNameValid = true;
      }

      if(this.upgrade.description == null || this.upgrade.description == "")
      {
        AllValid = false;
        this.upgradeDescValid = false;
        if(this.activeIndex !=0)
          this.messageService.add({ severity: 'error', summary: 'Description required', detail: 'You must provide a description for your Upgrade, please return to the first tab and correct this.'});
      }
      else
      {
        this.upgradeDescValid = true;
      }

      return AllValid;
    }
    
}

class UTCDate {
  private boundDateBacker: Date;
  constructor(private dateInstance: Date) {
    this.boundDateBacker = this.utcToLocal(dateInstance);
  }

  public get boundDate(): Date {
    return this.boundDateBacker;
  }
  public set boundDate(value: Date) {
    if (value) {
      this.dateInstance.setTime(this.localToUtc(value).getTime());
      const newTime = value.getTime();
      if (newTime !== this.boundDateBacker.getTime()) {
        this.boundDateBacker.setTime(newTime);
      }
    }
  }

  private localToUtc(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),  date.getHours(), date.getMinutes(), date.getSeconds()));
  }

  private utcToLocal(date: Date): Date {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),  date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  }
}
